import React from 'react'
import NavLinks from './NavLinks'
import PhoneNumber from './PhoneNumber'

const Navigation = () => {
return (
    <div>
    <div className="logo-spacing">
        <img
        className="logo"
        src="https://s3.amazonaws.com/tangledlead.com/images/Tangled+Lead.jpg"
        alt="Company Logo"
        />
        <PhoneNumber />
    </div>
    <NavLinks />
    </div>
)
}
export default Navigation
